import s from './style.css';
import cn from 'classnames';
import TextWithBackground from 'components/TextWithBackground';

const ChartTitle = ({
	tag = 'h2',
	children,
	center = true,
	tight,
	flush,
	...rest
}) => (
	<TextWithBackground
		bg="white"
		className={cn(s.text, {
			[s.tight]: tight,
			[s.flush]: flush,
			[s.center]: center
		})}
		tag={tag}
		{...rest}
	>
		{children}
	</TextWithBackground>
);

export default ChartTitle;



// WEBPACK FOOTER //
// ./components/ChartTitle/index.js